import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import "./style.scss";
import { FiX } from "react-icons/fi";
type Anchor = "right";

export default function AddInstructorModal({
  toggleDrawer,
  state,
  sendInvitationToUser,
  handleInput,
  inputs
}: {
  toggleDrawer: any,
  state: any,
  sendInvitationToUser: any,
  handleInput: any,
  inputs: any
}) {

  const list = (anchor: Anchor) => (
    <Box sx={{ width: 517, padding: 3 }} role="presentation">
      <div className="d-flex justify-content-between">
        <h2 className="heading2">Add New Instructor</h2>
        <span role="button" onClick={toggleDrawer("right", false)}>
          <FiX style={{ fontSize: 20 }} />
        </span>
      </div>
      <form action="" className="add_user_form">
        <h4 className="title">DETAILS</h4>
        <div className="input_group">
          <label htmlFor="">Instructor Name</label>
          <input type="text" name="toName" defaultValue={inputs.name} placeholder="Enter Name Here" onChange={handleInput} />
        </div>
        <div className="input_group">
          <label htmlFor="">Instructor Email</label>
          <input type="email" name="toEmail" defaultValue={inputs.email} placeholder="Enter Your Email" onChange={handleInput} />
        </div>
        <div className="row options my-4">
          <div className="col col-md-6">
            <label className="checkbox">
              Can view my logbook
              <input type="checkbox" name="canViewLogBook" checked={inputs.canViewLogBook} onChange={handleInput} />
              <span className="checkmark"></span>
            </label>
          </div>
          <div className="col col-md-6">
            <label className="checkbox">
              Can add flights to my logbook
              <input type="checkbox" name="canAddFlights" checked={inputs.canAddFlights} onChange={handleInput} />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
        <button className="button" onClick={sendInvitationToUser}>Add Instructor</button>
      </form>
    </Box>
  );

  return (
    <div>
      <React.Fragment>
        <Drawer
          anchor={"right"}
          open={state["right"]}
          onClose={toggleDrawer("right", false)}
        >
          {list("right")}
        </Drawer>
      </React.Fragment>
    </div>
  );
}
